import { all, call } from 'redux-saga/effects';
import {
    onCloseTransactionPanel,
    onSubscribeToStompBrokerTopic,
    onUnsubscribeFromStompBrokerTopic,
    onSetActiveTalkUrl,
    onSetActiveDemoTalkUrl,
    onHandleDeskAssignedMessage,
    onTransactionImageStatusReceived,
    onRefreshTransactionImages,
    onGetVideoWallCameras,
    onVideoWallNotificationTimedOut,
    onRememberFinishedVideoWallTransaction,
    onToggleVideoWallEnabled,
    onToggleIsReceivingTransactionsEnabled,
    onRegisterSharedWorker,
    onSendReportedIssues,
    onPublishVideoWallConfig,
    onSaveMultiWallConfig,
    onQueueNewVideoWallConfig,
} from './transactionsSagas';
import { onPinLane, onUnpinLane, onHydrateStickyLanes, onWindowDisconnectedFromSharedWorker } from './stickyLaneSagas';
import { onToggleTransactionsSplitViewMode } from './transactionSplitViewMode';

export function* transactionsSaga() {
    yield all([
        call(onCloseTransactionPanel),
        call(onUnsubscribeFromStompBrokerTopic),
        call(onSubscribeToStompBrokerTopic),
        call(onSetActiveTalkUrl),
        call(onSetActiveDemoTalkUrl),
        call(onHandleDeskAssignedMessage),
        call(onTransactionImageStatusReceived),
        call(onRefreshTransactionImages),
        call(onGetVideoWallCameras),
        call(onVideoWallNotificationTimedOut),
        call(onRememberFinishedVideoWallTransaction),
        call(onToggleVideoWallEnabled),
        call(onToggleIsReceivingTransactionsEnabled),
        call(onRegisterSharedWorker),
        call(onSendReportedIssues),
        call(onPublishVideoWallConfig),
        call(onSaveMultiWallConfig),
        call(onQueueNewVideoWallConfig),
        call(onPinLane),
        call(onUnpinLane),
        call(onHydrateStickyLanes),
        call(onWindowDisconnectedFromSharedWorker),
        call(onToggleTransactionsSplitViewMode),
    ]);
}
